// @flow
import * as React from 'react';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {SVGIcon} from '@homeaway/react-svg';
import {CALENDAR__16} from '@homeaway/svg-defs';

import {GENERIC_EVENT} from '../../utils/edapWrapper';

import FlexibleDatesProvider from './FlexibleDatesProvider';
import FlexibleDatesOption from './FlexibleDatesOption';

import type {FlexibleDatesDesktopMobileProps} from './FlexibleDates';

import './FlexibleDatesMobile.less';

export default function FlexibleDatesMobile({
    title,
    loading,
    options,
    startDate,
    endDate,
    resultCount,
    ...props
}: FlexibleDatesDesktopMobileProps) {
    // $FlowFixMe
    const trackingContext = React.useContext(TrackingContext);

    function onDropdownShow() {
        trackingContext.trigger(GENERIC_EVENT, {
            eventaction: 'dropdown opened'
        });
    }

    return (
        <div className="FlexibleDatesMobile">
            <Dropdown
                id="flexible-dates"
                onDropdownShow={onDropdownShow}
                label={
                    <>
                        <SVGIcon markup={CALENDAR__16} inline aria-hidden />
                        <span className="FlexibleDatesMobile__Label">
                            {title}
                        </span>
                    </>
                }
            >
                <FlexibleDatesProvider
                    loading={loading}
                    options={options}
                    startDate={startDate}
                    endDate={endDate}
                    resultCount={resultCount}
                >
                    {(flexibleDateOptions, isLoading) => {
                        return flexibleDateOptions.map((newOptions) => (
                            <DropdownItem
                                key={newOptions.id}
                                text={
                                    <div className="FlexibleDatesMobile__Item">
                                        <FlexibleDatesOption
                                            {...props}
                                            {...newOptions}
                                            loading={loading || isLoading}
                                        />
                                    </div>
                                }
                            />
                        ));
                    }}
                </FlexibleDatesProvider>
            </Dropdown>
        </div>
    );
}
